import { Link } from 'react-router-dom';
import { siteLinks } from '@/components/feature/SiteNav';

// Demo contact details — edit freely
const contact = {
  email: 'hello@fleurandform.com',
  phone: '+45 31 20 48 19',
  address: 'Jægersborggade 14, 2200 Copenhagen',
};

export default function Footer() {
  return (
    <footer className="ff-sans bg-[#F1F0EC] text-[#111111] px-4 md:px-10 pt-16 md:pt-24 pb-8">
      <p className="font-medium uppercase tracking-[-0.055em] leading-[0.85] text-[15vw] md:text-[9vw] whitespace-nowrap">
        Fleur <span className="ff-serif italic normal-case font-normal tracking-normal">&amp;</span> Form
      </p>
      <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-10 md:gap-6 text-[13px]">
        <p className="ff-serif italic text-[20px] md:text-[24px] leading-tight max-w-[320px]">A studio for flowers and form.</p>
        <div className="flex flex-col gap-2">
          <span className="text-[11px] text-black/40 mb-1">Contact</span>
          <a href={`mailto:${contact.email}`} className="w-fit border-b border-black/30 hover:border-black transition-colors cursor-pointer whitespace-nowrap">{contact.email}</a>
          <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="w-fit hover:opacity-50 transition-opacity cursor-pointer whitespace-nowrap">{contact.phone}</a>
          <span className="text-black/50">{contact.address}</span>
        </div>
        <nav className="flex flex-col gap-2" aria-label="Footer">
          <span className="text-[11px] text-black/40 mb-1">Index</span>
          {siteLinks.map((l) => (
            <Link key={l.label} to={l.to} className="w-fit hover:opacity-50 transition-opacity cursor-pointer whitespace-nowrap">{l.label}</Link>
          ))}
          <Link to="/#bespoke" className="w-fit text-black/55 hover:text-black transition-colors cursor-pointer whitespace-nowrap">Bespoke enquiry</Link>
        </nav>
      </div>
      <div className="mt-14 md:mt-20 pt-6 border-t border-black/10 flex flex-col sm:flex-row justify-between gap-2 text-[11px] md:text-[12px] text-black/50">
        <span>© 2026 Fleur &amp; Form. Demo template — contact details are placeholders.</span>
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="w-fit hover:text-black transition-colors cursor-pointer whitespace-nowrap">Back to top ↑</button>
      </div>
    </footer>
  );
}